/**
 * Şerit Rallisi ortak eğitim kuralları. Bilgi puanı yalnız doğru cevaptan gelir; yoldaki altın bonusu ayrı tutulur ve
 * sunucuda olay sırasından yeniden hesaplanır. Engel çarpması puanı etkilemez, yalnız rapor için sayılır.
 */
export const LANE_RALLY_RULES = {
  minQuestions: 5, maxQuestions: 20, minChoices: 2, maxChoices: 4,
  correctScore: 100, feedbackMs: 2000,
} as const;

export const LANE_RALLY_BONUS = { coinScore: 10, coinsPerStretch: 3, obstaclesPerStretch: 2 } as const;
export type LaneRallyBonusEvent = 'coin' | 'obstacle';

export function laneRallyScore(correct: boolean) { return correct ? LANE_RALLY_RULES.correctScore : 0; }

/** En yüksek geçerli puan: bütün sorular doğru ve her yol kesiminde bütün altınlar. */
export function laneRallyMaximumScore(correct: number, questionCount: number) {
  return correct * LANE_RALLY_RULES.correctScore
    + Math.max(0, questionCount - 1) * LANE_RALLY_BONUS.coinsPerStretch * LANE_RALLY_BONUS.coinScore;
}

/** İstemci ve sunucunun aynı sonucu üretmesi için yol kesimi olaylarını sırasıyla yeniden oynatır. */
export function replayLaneRallyBonus(stretches: readonly (readonly LaneRallyBonusEvent[])[]) {
  let coins = 0, obstacleHits = 0;
  for (const stretch of stretches) for (const event of stretch) {
    if (event === 'coin') coins += 1; else obstacleHits += 1;
  }
  return { points: coins * LANE_RALLY_BONUS.coinScore, coins, obstacleHits };
}
